import React, {Component} from '../lib/react.js'
import moment from 'moment'

export default class extends Component {
  render() {
    let value = this.props.date
    value = value && moment(value).fromNow()
    return <span>{value && (value.includes('day') || value.includes('month') || value.includes('year')) ? value : 'today'}</span>
  }

}


// WEBPACK FOOTER //
// ./src/components/TimeAgo.js